import { addCustomAttribute } from '@ohif/core/src/hanging-protocols/customAttributes';

export const registerCustomAttributes = () => {
  addCustomAttribute('Modality', 'Modality', (instance) => {
    if (typeof instance.getTagValue === 'function') {
      return instance.getTagValue('Modality');
    }
    if (instance.Modality) return instance.Modality;
    if (instance.study && instance.study.Modality) return instance.study.Modality;
    if (instance._data && instance._data.Modality) return instance._data.Modality;
    return undefined;
  });

  addCustomAttribute('ViewPosition', 'View Position', (instance) => {
    if (typeof instance.getTagValue === 'function') {
      return instance.getTagValue('ViewPosition');
    }

    if (instance.ViewPosition) return instance.ViewPosition;
    if (instance.images && instance.images.length > 0) {
      const image = instance.images[0];
      return image.ViewPosition || image.SeriesDescription;
    }
    return undefined;
  });

  addCustomAttribute('ImageLaterality', 'Image Laterality', (instance) => {
    if (typeof instance.getTagValue === 'function') {
      return instance.getTagValue('ImageLaterality') ||
        instance.getTagValue('FrameLaterality') ||
        instance.getTagValue('Laterality');
    }

    if (instance.ImageLaterality) return instance.ImageLaterality;
    if (instance.FrameLaterality) return instance.FrameLaterality;
    if (instance.Laterality) return instance.Laterality;

    if (instance.images && instance.images.length > 0) {
      const image = instance.images[0];
      return image.ImageLaterality || image.FrameLaterality || image.Laterality;
    }
    return undefined;
  });
};
